import {
  useCurrentUser,
  useCurriculum,
  useSubjectList,
} from "@twinkltech/curriculum-architect-domain-hooks";
import { useParams } from "react-router-dom";

import { SubjectList } from "./SubjectList";

export const SubjectListContainer = () => {
  const { curriculum_id } = useParams();

  if (!curriculum_id) {
    throw new Error("Missing curriculum_id");
  }

  const {
    data,
    error: curriculumError,
    isLoading,
  } = useCurriculum({
    id: curriculum_id,
  });

  const {
    data: subjectList,
    error: subjectListError,
    isLoading: isLoadingSubjects,
  } = useSubjectList({
    curriculumId: curriculum_id,
  });

  const { data: user, error: userError } = useCurrentUser();

  const isSchoolUser = user?.persona.accountType !== "individual";

  return (
    <SubjectList
      curriculum={data}
      error={curriculumError || subjectListError || userError}
      isLoading={isLoading || isLoadingSubjects}
      isSchoolUser={isSchoolUser}
      subjectList={subjectList}
    />
  );
};
